import styled from '@emotion/styled';
import {sizes} from 'patient-ping-remedy/packages/theme';
import {StandardTypography} from 'patient-ping-remedy/packages/typography';

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  padding: ${sizes.medium} ${sizes.medium} 0 ${sizes.medium};
`;

export const TableWrapper = styled.div`
  overflow-y: auto;
  padding: ${sizes.medium};
`;

export const EmptyTable = styled(StandardTypography)`
  display: block;
  text-align: center;
`;

export const AttachmentTitle = styled.div`
  display: flex;
  align-items: center;
`;

export const AttachmentActions = styled.div`
  display: flex;
  justify-content: end;
`;
